import React, { Component } from "react";
import { AgGridReact as AgGridReactMiscd } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import Header from "../../header/header";
import axios from "axios";
import { getHeadersOrder } from "../../utility/utility";

class MoneyTransferMISCD extends Component {
  state = {
    mtcn: '',
    columns: [
      {
        field: "momiscrt",
        headerName: "Typ",
        width: 80,
      },
      {
        field: "dateTime",
        headerName: "DT",
        width: 200,
        sortable: false,
        filter: false,
        floatingFilter: false,
      },
      {
        field: "occurs",
        headerName: "Occurs",
        width: 100,
      },
      {
        field: "details",
        headerName: "Details",
        width: 650,
      },
    ],
    rows: null,
    paginationValMISCDMTCN: "25",
    defaultColumnDef: {
      resizable: true,
      //flex: 1,
      sortable: true,
      filter: true,
      floatingFilter: true,
    },
    overlayLoadingTemplateMiscd:
    '<span class="ag-overlay-loading-center">Loading...</span>',
    overlayNoRowsTemplateMiscd:
    '<span style="">No Records Found</span>',
    paginationOptionHistoryMTCN: [25, 50, 100, 500],
    paginationOptionMISCDMTCN: [25, 50, 100, 500],
  };

  componentDidMount() {
    this.setState({
      mtcn: this.props.history.location.mtcn,
      jwtToken: this.props.history.location.jwtToken
    })
  }

  onPageSizeChangedMISCDMTCN = (e) => {
    this.setState({ paginationValMISCDMTCN: e.target.value });
    this.state.gridApi.paginationSetPageSize(Number(e.target.value));
  };

  onChangeControlMISCDMTCN = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onGridReadyMISCDMTCN = (params) => {
    if (params) {
      this.setState({ gridApi: params.api });
    }
    let submittedObj = {};
    submittedObj.mtcn = this.state.mtcn;
    axios.post(`${process.env.REACT_APP_DB_VIEW_BASE_ORDER_SERVICE_URL}/v1/ord/dbview/moneytransferutility/misc`,submittedObj,
    {
      headers: {
        ...getHeadersOrder().headers,
        Authorization: this.state.jwtToken
      },
    }
    ).then((response) => {
      if(response.data.flag === 1) {
        this.setState({
          rows: response.data.records
        });
      } else {
        this.setState({
          rows:[],
          overlayNoRowsTemplateMiscd:`<span style="">${response.data.message}</span>`
        });
      }
    });
  };

  onHandleBackMISCDMTCNDetails = () => {
    this.props.history.push({
      pathname: "/mt-database-money-transfer-record",
      jwtToken: this.state.jwtToken
    });
  };

  onHandleBackMISCDMTCNSearch = () => {
    this.props.history.push({
      pathname: "/money-transfer-database-utility",
    });
  };

  render() {
    return (
      <div>
        <Header history={this.props.history} heading="MONEY TRANSFER UTILITY" />
        <div className="container-fluid">
          <div className="card-body">
            <div className="card">
              <div className="card-header bg-dark text-white card-header-custom">
                Money Transfer Miscellaneous Record
              </div>
              <div className="card-body card-body-custom">
                <div className="form-row">
                  <div className="col-lg-1" />
                  <div className="col-lg-2">
                    <label htmlFor="mtcn"><span className="font-weight-bold">MTCN : </span>{this.state.mtcn}</label>
                  </div>
                  <div className="col-lg-9" />
                </div>
                <div className="row">
                  <div className="col-lg-1" />
                  <div className="col-lg-3">
                    <div className="pagination-dropdown float-left">
                      <label htmlFor="pagination-select-label" className="font-weight-bold">
                        No of records per page:
                      </label>
                      <select
                        className="form-control form-control-sm"
                        onChange={(e) => {
                          this.onChangeControlMISCDMTCN(e);
                          this.onPageSizeChangedMISCDMTCN(e);
                        }}
                        value={this.state.paginationValMISCDMTCN}
                        name="paginationDropdownMISCDMTCN"
                        data-test="select-dropdown"
                      >
                        {this.state.paginationOptionMISCDMTCN.map((val) => {
                          return (
                            <option key={val} value={val}>
                              {val}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-8" />
                </div>
                <div className="d-flex justify-content-center ">
                  <div
                    className="ag-theme-balham "
                    style={{ height: 290, width: "83%" }}
                  >
                    <AgGridReactMiscd
                      rowData={this.state.rows}
                      columnDefs={this.state.columns}
                      defaultColDef={this.state.defaultColumnDef}
                      pagination={true}
                      paginationPageSize={25}
                      onGridReady={this.onGridReadyMISCDMTCN}
                      overlayLoadingTemplate={this.state.overlayLoadingTemplateMiscd}
                      overlayNoRowsTemplate={this.state.overlayNoRowsTemplateMiscd}
                      data-test="component-grid"
                      enableCellTextSelection={true}
                    ></AgGridReactMiscd>
                  </div>
                </div>
                <div className="text-center mt-2">
                  <button
                    type="button"
                    className="btn btn-warning mr-2"
                    onClick={this.onHandleBackMISCDMTCNDetails}
                    data-test='MTCNDetails-button-back'
                  >
                    MTCN Details
                  </button>
                  <button
                    type="button"
                    className="btn btn-warning mar-right10"
                    onClick={this.onHandleBackMISCDMTCNSearch}
                    data-test='Search-button-back'
                  >
                    SEARCH
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default MoneyTransferMISCD;
